import { render } from "./Points.vue?vue&type=template&id=4ba0e650&scoped=true&ts=true"
import script from "./Points.vue?vue&type=script&lang=ts"
export * from "./Points.vue?vue&type=script&lang=ts"

import "./Points.vue?vue&type=style&index=0&id=4ba0e650&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ba0e650"]])

export default __exports__